import { NextSeo } from 'next-seo';
import { useGlobal } from '@/utils/useGlobal';

type SEO = {
    locale?: string;
    title?: string;
    keywords?: string;
    description?: string;
    titleTemplate?: string;
    additionalMetaTags?: Array<any>;
    hideTitleTemplate?: boolean;
};

const genKeywords = (words: string) => ({
    name: 'keywords',
    content: words,
});

export default function SEO({ title, keywords, description, titleTemplate = '', hideTitleTemplate = false }: SEO) {
    const { useRouter } = useGlobal();
    const { locale, pathname } = useRouter();
    //首页title的模板会跟其它页面不一样
    const isHome = pathname === '/';
    const isBlogPage = (pathname || '').includes('blog/');

    const seo: SEO = {
        titleTemplate: titleTemplate ? `%s | ${titleTemplate}` : isHome ? `EcoFlow ${locale.toUpperCase()} | %s` : `%s | EcoFlow ${locale.toUpperCase()}`,
    };

    if (hideTitleTemplate || !!isBlogPage) {
        seo.titleTemplate = '';
    }

    // if (['sa'].includes(locale)) {
    //     seo.titleTemplate = '%s | ايكو فلو EcoFlow Arabia';
    // }

    if (['kr'].includes(locale)) {
        seo.titleTemplate = '%s';
    }

    if (title) {
        seo.title = title;
    }

    if (keywords) {
        seo.additionalMetaTags = [genKeywords(keywords)];
    }

    if (description) {
        seo.description = description;
    }

    return <NextSeo {...seo} />;
}
